import React, { useState } from 'react'
import styled from 'styled-components'
import DataUnionStatsMockup from '~shared/Mockup/DataUnionStatsMockup'
import ProductEditorMockup from '~shared/Mockup/ProductEditorMockup'
import DataUnionDeployMockup from '~shared/Mockup/DataUnionDeployMockup'
import Container from '~shared/Container'
import Gallery, { slideIndex } from '~shared/Gallery'

const CoreGallery = (props) => {
    const [slide, setSlide] = useState(0)

    const index = slideIndex(slide, 3)

    return (
        <div {...props}>
            <Container>
                <Gallery.Viewport $appear>
                    <Gallery
                        slide={slide}
                        onChange={setSlide}
                    >
                        <Gallery.Item as="div" disabled={index !== 0}>
                            <DataUnionStatsMockup />
                        </Gallery.Item>
                        <Gallery.Item as="div" disabled={index !== 1}>
                            <ProductEditorMockup />
                        </Gallery.Item>
                        <Gallery.Item as="div" disabled={index !== 2}>
                            <DataUnionDeployMockup />
                        </Gallery.Item>
                    </Gallery>
                </Gallery.Viewport>
            </Container>
        </div>
    )
}

export default styled(CoreGallery)``
